{
  "version": 1,
  "asset_id": "95a64bb7-60c2-40d2-9351-b8415bded2d3",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/95a64bb7-60c2-40d2-9351-b8415bded2d3/beverly-hills-shingle-replacement-in-progress-1280w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/95a64bb7-60c2-40d2-9351-b8415bded2d3/beverly-hills-shingle-replacement-in-progress-1280w.avif",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-1280w.avif",
  "size": 85074,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:32Z"
}
